import { Routes } from "@angular/router";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { ModuleListComponent } from "./component/module-list/module-list.component";
import { AddModuleComponent } from "./component/add-module/add-module.component";
import { ModuleDetailsComponent } from "./component/module-details/module-details.component";

export const MODULE_ROUTES: Routes = [
	{
		path: 'module',
		component: LayoutComponent,
		canActivate: [MsalGuard],
		children: [
            { path: '', component: ModuleListComponent },
            { path: 'add', component: AddModuleComponent },
            { path: ':id', component: ModuleDetailsComponent }
		]
	}
];
